/**
 * @fileoverview GET handler for the "/alloys/adjust/custom_events/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { alloysAdjustCustomEventsAppGroupId } from "./constants";
import type { GetAlloysAdjustCustomEventsAppGroupIdResult } from "./types";
import { isGetAlloysAdjustCustomEventsAppGroupIdResult } from "./validators";

export const getAlloysAdjustCustomEventsAppGroupId = reactQueryFetcherAdapter(
  alloysAdjustCustomEventsAppGroupId,
  (signal: AbortSignal, appGroupId: string): Promise<GetAlloysAdjustCustomEventsAppGroupIdResult> => {
    return fetch(
      `/alloys/adjust/custom_events/${appGroupId}`,
      "GET",
      {},
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isGetAlloysAdjustCustomEventsAppGroupIdResult
);
